import { render } from "./ManufacturerSelect.vue?vue&type=template&id=98cdf482"
import script from "./ManufacturerSelect.vue?vue&type=script&lang=js"
export * from "./ManufacturerSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/v3/ManufacturerSelect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "98cdf482"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('98cdf482', __exports__)) {
    api.reload('98cdf482', __exports__)
  }
  
  module.hot.accept("./ManufacturerSelect.vue?vue&type=template&id=98cdf482", () => {
    api.rerender('98cdf482', render)
  })

}


export default __exports__